import React from 'react';
import { Typography, Avatar, ListItemText, ListItemAvatar, ListItemButton, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ChangeChip from './ChangeChip';

const CustomListItem = ({ a, b, showB, text, icon, periodColours, onClick = null, lastItem = false, showChange = true }) => {
    const theme = useTheme();
    const change = showB ? b - a : 0;

    return (
        <ListItemButton
            divider={!lastItem}
            onClick={onClick}
            disabled={!onClick} // temporary, these should all have click-throughs
        >
            <ListItemAvatar>
                <Avatar>
                    {icon}
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={(
                    <React.Fragment>
                        {new Intl.NumberFormat().format(a)}
                        {showB && (
                            <React.Fragment>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontWeight: 'normal',
                                        lineHeight: 1,
                                        display: 'inline',
                                        mx: 0.5,
                                        color: theme.palette.text.secondary
                                    }}
                                >
                                    vs
                                </Typography>
                                <Box component="span" sx={{ display: 'inline', color: periodColours[1], lineHeight: 1 }}>
                                    {new Intl.NumberFormat().format(b)}
                                </Box>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
                slotProps={{
                    primary: {
                        color: periodColours[0],
                        variant: 'h6',
                        fontWeight: 'bold',
                        lineHeight: 1
                    }
                }}
                secondary={text}
            />
            {(showChange && showB) && (
                <ChangeChip
                    a={a}
                    b={b}
                    change={change}
                />
            )}
        </ListItemButton>
    );
};

export default CustomListItem;